export const HEALTHY_CONTRIBUTIONS_LEGAL_NAME_WITH_COPYRIGHT = 'Healthy Contributions SPV® LLC';
export const HEALTHY_CONTRIBUTIONS_LEGAL_NAME = 'Healthy Contributions SPV LLC';
export const HEALTHY_CONTRIBUTIONS_NAME = 'Healthy Contributions';
export const OPTUM_NAME = 'One Pass Solutions, Inc.';